/**
 * Product Compare — mini (E20-1077)
 *
 * Swaps the right column's card when the shopper changes the selector. Each
 * selectable product is pre-rendered into a <template>; on change we clone the
 * matching template into the right card. <compare-heights> re-aligns the rows
 * automatically via its own MutationObserver, so no manual re-measure is needed.
 *
 * The left column is locked to the current product and never swaps.
 */
(() => {
  // Run once per page — the section injects this via <script src>, so guard against
  // duplicate module-level listeners if the section renders more than once.
  if (window.bfxMiniCompareLoaded) return;
  window.bfxMiniCompareLoaded = true;

  const swapRight = (root, sectionId, handle) => {
    const template = root.querySelector(
      `#mini-compare-tpl-${CSS.escape(sectionId)}-${CSS.escape(handle)}`
    );
    const card = root.querySelector('[data-compare-card][data-slot="right"]');
    if (!template || !card) return;

    card.replaceChildren(template.content.cloneNode(true));

    // Let integrations react to the new product (e.g. re-scan Bazaarvoice ratings,
    // which are injected after BV's initial page scan and need a nudge to render).
    root.dispatchEvent(
      new CustomEvent('mini-compare:swapped', { bubbles: true, detail: { handle } })
    );
  };

  const init = (root) => {
    if (root.dataset.miniCompareReady === 'true') return;

    const sectionId = root.dataset.sectionId;
    const select = root.querySelector('[data-mini-compare-select]');
    if (!sectionId || !select) return;

    // Mark ready only once the required elements are present and bound, so a partial
    // editor render can still re-init later.
    root.dataset.miniCompareReady = 'true';
    select.addEventListener('change', () => swapRight(root, sectionId, select.value));
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-mini-compare]').forEach(init);

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });

  // Shopify theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
